module.exports = __webpack_public_path__ + "static/logo-1f27d369f7a4cd88df0ec272bf4c49fb.png";